"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedCardBrands = exports.COMMON_CARD_BRANDS = void 0;
const CreditCardNetwork_1 = require("../enums/payments/CreditCardNetwork");
const PaymentProvider_1 = require("../enums/payments/PaymentProvider");
// TODO: [TEMP SOLUTION] BE should start to send us available card networks for each provider in future
const PROVIDERS_WITHOUT_AMEX = [
    PaymentProvider_1.PaymentProvider.Isracard,
    PaymentProvider_1.PaymentProvider.LeumiCard,
    '21989bb9-441b-4ba2-afa8-0e5bf9b9f20e',
    'f051b8ae-8675-42bd-a492-6cab9a69934a',
    '10382e2b-e20d-444f-8c1f-6b61e1cc9001',
    'd4c66807-090c-46ea-add7-93470c2b9132',
    '5969c7b3-6d57-4e05-b3ff-213cc828a782',
    'da649db4-2c9d-4c3e-99cf-37ddd1ecefbf',
];
exports.COMMON_CARD_BRANDS = [
    CreditCardNetwork_1.CreditCardNetwork.MasterCard,
    CreditCardNetwork_1.CreditCardNetwork.Visa,
    CreditCardNetwork_1.CreditCardNetwork.Amex,
    CreditCardNetwork_1.CreditCardNetwork.Maestro,
];
const getSupportedCardBrands = (providerId) => {
    if (PROVIDERS_WITHOUT_AMEX.includes(providerId)) {
        return exports.COMMON_CARD_BRANDS.filter((brand) => brand !== CreditCardNetwork_1.CreditCardNetwork.Amex);
    }
    return exports.COMMON_CARD_BRANDS;
};
exports.getSupportedCardBrands = getSupportedCardBrands;
//# sourceMappingURL=getSupportedCardBrands.js.map